var render = function render(){var _vm=this,_c=_vm._self._c;return _c('page-secondary',{staticClass:"pc-content",attrs:{"header":_vm.headerOptions}},[_c('page-container',_vm._l((_vm.progressData),function(progress){return _c('div',{key:progress._id},[_c('card-member-progress',{attrs:{"progress-details":progress}})],1)}),0)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }